import { useState, useEffect } from 'react';
import editUserServices from '../../services/edit-users/edit-users.service';
import { CustomerReportResponse } from '../../models/all-user/edit-user-model';
import CustomerReportDataTable from './Customer-datatable';
import AppLoading from '../app-loading/app-loading';
import { Button } from 'primereact/button';
import { exportCustomerReport } from './Customer-report-export';

const CustomerReportMain = () => {
  const [reportData, setReportData] = useState<CustomerReportResponse>({
    columns: [],
    data: []
  });

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchReportData = async () => {
      try {
        setIsLoading(true);
        const data = await editUserServices.getCustomerReport();
        setReportData(data);
      } catch (err) {
        setReportData({ columns: [], data: [] });
      } finally {
        setIsLoading(false);
      }
    };
    fetchReportData();
  }, []);

  const handleExport = () => {
    exportCustomerReport(reportData.columns, reportData.data);
  };

  if (isLoading) return <AppLoading />; 

  return (
  <div className="layout-content mt-3 mb-3 grid grid-table-mobile">
    <div className="col-12">
      <div className="flex align-items-center justify-content-between flex-wrap gap-2 w-full card-container mb-0">
        <h5 className="ml-1 mb-0">Customer Report</h5>
        <span>
          <Button
            className="text-black border-round mr-2"
            onClick={handleExport}
            icon="pi pi-file-export mr-1"
            text
            raised
            disabled={reportData.data.length === 0}
          >
            Export Report
          </Button>
        </span>
      </div>
    </div>

    <div className="report-container col-12">
      <CustomerReportDataTable 
        columns={reportData.columns} 
        data={reportData.data} 
        isLoading={isLoading}
      />
    </div>
  </div>
);

};

export default CustomerReportMain;
